import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="flex items-center justify-between" data-id="element-92">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2" data-id="element-93">
            <div className="w-8 h-8 rounded-lg bg-sky-500 flex items-center justify-center text-white font-bold" data-id="element-94">
              N
            </div>
            <span className="text-xl font-bold text-sky-900 tracking-tight" data-id="element-95">
              Nimbusquest
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-96">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-sky-600 transition-colors" data-id="element-97">
                {link.name}
              </a>)}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-98">
            <a href="#cta" className="inline-flex items-center justify-center px-5 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-sky-500 hover:bg-sky-600 transition-colors shadow-sm hover:shadow-md" data-id="element-99">
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-100">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-md text-slate-600 hover:text-sky-600 hover:bg-sky-50 transition-colors" aria-label="Toggle menu" data-id="element-101">
              {isMobileMenuOpen ? <X size={24} data-id="element-102" /> : <Menu size={24} data-id="element-103" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-104">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-sky-100 overflow-hidden" data-id="element-105">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-106">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-sky-600 hover:bg-sky-50" data-id="element-107">
                  {link.name}
                </a>)}
              <div className="pt-4 px-3" data-id="element-108">
                <a href="#cta" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-center px-5 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-sky-500 hover:bg-sky-600 shadow-sm" data-id="element-109">
                  Get Started
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}